import React, { useEffect, useMemo, useState } from "react";
import api from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Check, Lock } from "lucide-react";

const up = (s) => String(s || "").toLocaleUpperCase("tr-TR").trim();

export const areaSummary = (iller = [], ilceler = []) => {
  const m = {};
  ilceler.forEach((x) => { const [il, d, mh] = x.split("/"); m[il] = m[il] || { d: new Set(), mh: 0 }; if (mh) m[il].mh += 1; else m[il].d.add(d); });
  const parts = [...iller.map((il) => `${il} (TÜMÜ)`), ...Object.entries(m).map(([il, v]) => `${il}: ${[v.d.size ? `${v.d.size} İLÇE` : "", v.mh ? `${v.mh} MAHALLE` : ""].filter(Boolean).join(" + ")}`)];
  return parts.length ? parts.join(", ") : "HİZMET ALANI SEÇİLMEDİ";
};

export function AreaPicker({ open, onClose, value, taken, onApply }) {
  const [geo, setGeo] = useState({});
  const [il, setIl] = useState("");
  const [q, setQ] = useState("");
  const [iller, setIller] = useState([]);
  const [ilceler, setIlceler] = useState([]);
  useEffect(() => { if (open && !Object.keys(geo).length) api.get("/geo/all").then((r) => setGeo(r.data)).catch(() => {}); }, [open, geo]);
  useEffect(() => { if (open) { setIller(value.iller || []); setIlceler(value.ilceler || []); setIl(""); } }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  const list = useMemo(() => Object.keys(geo).filter((x) => x.includes(up(q))), [geo, q]);
  const cnt = (p) => ilceler.filter((x) => x.startsWith(p + "/") && x.split("/").length === 2).length;
  const takenIl = (p) => taken.iller[p];
  const takenIlce = (p, d) => taken.ilceler[`${p}/${d}`];
  const toggleIl = (p) => setIller((a) => (a.includes(p) ? a.filter((x) => x !== p) : [...a, p]));
  const toggleIlce = (p, d) => { const k = `${p}/${d}`; setIlceler((a) => (a.includes(k) ? a.filter((x) => x !== k) : [...a, k])); };
  const allIlce = (p, on) => setIlceler((a) => { const rest = a.filter((x) => !x.startsWith(p + "/")); return on ? [...rest, ...(geo[p] || []).filter((d) => !takenIlce(p, d)).map((d) => `${p}/${d}`)] : rest; });
  const mahalle = (p, d) => {
    const v = window.prompt(`${d} İLÇESİ ${takenIlce(p, d) || "BAŞKA ŞUBE"} İLE PAYLAŞILACAK (ÖZEL İZİN). BU ŞUBEYE AİT MAHALLELERİ VİRGÜLLE YAZIN:`);
    if (!v) return;
    const add = v.split(",").map(up).filter(Boolean).map((m) => `${p}/${d}/${m}`);
    setIlceler((a) => [...a.filter((x) => !add.includes(x)), ...add]);
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="area-picker" className="max-w-4xl border-slate-700 bg-slate-900 text-slate-100">
        <DialogHeader><DialogTitle>HİZMET ALANI SEÇ — İL / İLÇE</DialogTitle></DialogHeader>
        <div className="grid h-[60vh] grid-cols-[260px_1fr] gap-3">
          <div className="flex min-h-0 flex-col">
            <Input data-testid="area-il-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="İL ARA" className="mb-2 h-8 border-slate-700 bg-slate-800 text-xs" />
            <div className="min-h-0 flex-1 overflow-auto rounded border border-slate-800">
              {list.map((p) => (
                <button key={p} data-testid={`area-il-${p}`} onClick={() => setIl(p)} className={`flex w-full items-center gap-2 px-2 py-1.5 text-left text-xs ${il === p ? "bg-blue-600/30 text-white" : "text-slate-300 hover:bg-slate-800"}`}>
                  <span className="flex-1">{p}</span>
                  {iller.includes(p) && <span className="rounded bg-emerald-600 px-1 text-[10px] font-bold text-white">TÜMÜ</span>}
                  {!iller.includes(p) && cnt(p) > 0 && <span className="rounded bg-sky-700 px-1 text-[10px] font-bold text-white">{cnt(p)} İLÇE</span>}
                  {takenIl(p) && <Lock className="h-3 w-3 text-slate-500" />}
                </button>
              ))}
            </div>
          </div>
          <div className="min-h-0 overflow-auto rounded border border-slate-800 p-2">
            {!il ? <div className="p-6 text-center text-xs text-slate-500">SOLDAN BİR İL SEÇİN — İLÇELERİ OTOMATİK GELİR</div> : (
              <>
                <div className="mb-2 flex flex-wrap items-center gap-2">
                  <b className="text-sm">{il}</b>
                  {takenIl(il) && !iller.includes(il) ? <span className="text-[11px] text-slate-500">İLİN TAMAMI {takenIl(il)} ŞUBESİNDE — SADECE İLÇE SEÇEBİLİRSİNİZ</span> : (
                    <label className="flex items-center gap-1 text-xs"><input data-testid="area-il-all" type="checkbox" checked={iller.includes(il)} onChange={() => toggleIl(il)} /> İLİN TAMAMI BU ŞUBEDE</label>
                  )}
                  <button data-testid="area-ilce-all" onClick={() => allIlce(il, true)} className="rounded border border-slate-700 px-2 py-0.5 text-[11px] text-slate-300 hover:bg-slate-800">BOŞ İLÇELERİN HEPSİNİ SEÇ</button>
                  <button data-testid="area-ilce-none" onClick={() => allIlce(il, false)} className="rounded border border-slate-700 px-2 py-0.5 text-[11px] text-slate-300 hover:bg-slate-800">İLÇE SEÇİMİNİ TEMİZLE</button>
                </div>
                <div className="grid grid-cols-2 gap-1 md:grid-cols-3">
                  {(geo[il] || []).map((d) => {
                    const k = `${il}/${d}`; const on = ilceler.includes(k); const tk = takenIlce(il, d); const mh = ilceler.filter((x) => x.startsWith(k + "/"));
                    return (
                      <div key={d} data-testid={`area-ilce-${d}`} className={`rounded border px-2 py-1 text-xs ${on ? "border-emerald-600 bg-emerald-600/15" : tk ? "border-slate-800 bg-slate-800/40 text-slate-500" : "border-slate-800"}`}>
                        {tk && !on ? (
                          <div>
                            <div className="flex items-center gap-1"><Lock className="h-3 w-3" /> {d} <span className="truncate text-[10px]">· {tk}</span></div>
                            <button data-testid={`area-mahalle-${d}`} onClick={() => mahalle(il, d)} className="mt-0.5 text-[10px] font-bold text-amber-400 hover:underline">ÖZEL İZİN: MAHALLE İLE PAYLAŞ</button>
                            {mh.length > 0 && <div className="text-[10px] text-amber-300">{mh.map((x) => x.split("/")[2]).join(", ")} <button onClick={() => setIlceler((a) => a.filter((x) => !x.startsWith(k + "/")))} className="text-rose-400">✕</button></div>}
                          </div>
                        ) : (
                          <label className={`flex items-center gap-1 ${iller.includes(il) ? "text-slate-500" : "cursor-pointer"}`}><input type="checkbox" disabled={iller.includes(il)} checked={on || iller.includes(il)} onChange={() => toggleIlce(il, d)} /> {d}</label>
                        )}
                      </div>
                    );
                  })}
                </div>
              </>
            )}
          </div>
        </div>
        <div className="flex items-center gap-2">
          <span className="flex-1 truncate text-[11px] text-slate-400">{areaSummary(iller, ilceler)}</span>
          <Button variant="outline" data-testid="area-cancel" onClick={onClose} className="border-slate-700">VAZGEÇ</Button>
          <Button data-testid="area-apply" onClick={() => { onApply({ iller, ilceler }); onClose(); }} className="bg-emerald-600 text-white hover:bg-emerald-700"><Check className="mr-1 h-4 w-4" /> UYGULA</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
